<script>
  import Canvas from "./Canvas.svelte";
  import Menu from "./Menu.svelte";
  import Overlays from "./Overlays.svelte";
  import TitleCard from "./TitleCard.svelte";
  import Help from "./Help.svelte";

  import { onMount } from "svelte";

  import { mode } from "./stores/globalControls";
  import { loadFromUrl, startSync } from "./lib/share.js";

  onMount(() => {
    loadFromUrl();
    return startSync();
  });
</script>

{#if $mode === "help"}
  <Help />
{/if}

<Overlays />
<Menu />
<!-- -->
<TitleCard />
<!-- -->
<Canvas />

<style>
  :global(body) {
    padding: 0;
    overflow: hidden;
    touch-action: none;
    /* The map and controls aren't text; selecting them is only ever accidental.
       The help dialog opts back in. */
    -webkit-user-select: none;
    user-select: none;
  }
</style>
